var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkipPrevious(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "skip_previous",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6 4.12744H8V16.1274H6V4.12744ZM9.5 10.1274L18 16.1274V4.12744L9.5 10.1274Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkipPrevious);
export default __webpack_public_path__ + "static/media/skip_previous.f4596f8b44a3278bc9ca40fcf26d7f3f.svg";
export { ForwardRef as ReactComponent };